import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Footer = () => {
  const location = useLocation();
  // On desktop, hide footer unless on home page
  const desktopHide = location.pathname !== '/' ? 'md:hidden' : '';
  return (
    <footer className={`bg-green-50 border-t border-green-200 text-center py-4 text-sm text-gray-700 relative z-10 pb-16 md:pb-4 ${desktopHide}`}>
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex flex-wrap justify-center gap-4 mb-2">
          <Link to="/privacy-policy" className="hover:text-green-600 hover:underline transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms-and-conditions" className="hover:text-green-600 hover:underline transition-colors">
            Terms & Conditions
          </Link>
          <Link to="/shipping-and-delivery" className="hover:text-green-600 hover:underline transition-colors">
            Shipping & Delivery
          </Link>
          <Link to="/cancellation-refund" className="hover:text-green-600 hover:underline transition-colors">
            Cancellation & Refund
          </Link>
          <Link to="/contact-us" className="hover:text-green-600 hover:underline transition-colors">
            Contact Us
          </Link>
        </div>
        <div className="flex items-center justify-center mt-2 mb-2 space-x-2">
          <img
            src="/images/fssai-logo.png"
            alt="FSSAI Logo"
            style={{ height: 20, width: 'auto' }}
            className="inline-block align-middle"
          />
          <span className="text-xs text-gray-600">
            FSSAI: 23625023000843
          </span>
        </div>
        <div className="text-xs text-gray-500 pb-2 md:pb-0">
          JR-Home Made Foods © {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};

export default Footer; 